import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import PhoneInput from 'react-phone-input-2';
import classnames from 'classnames';
import 'react-phone-input-2/lib/style.css';
export default function PhoneField({ id, value, className, containerClassName, onChange, disabled, }) {
    function handleChange(e) {
        onChange(e);
    }
    return (React.createElement(PhoneInput, { inputClass: classnames('w-full', className), containerClass: containerClassName, country: COUNTRY_CODE, placeholder: "334-333-3333", value: value, onChange: handleChange, id: id, disabled: disabled }));
}
PhoneField.propTypes = {
    id: PropTypes.string.isRequired,
    value: PropTypes.string,
    className: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
    onChange: PropTypes.func.isRequired,
    disabled: PropTypes.bool,
};
PhoneField.defaultProps = {
    value: '',
    disabled: false,
};
